import { ReactNode } from 'react'

import { Box, HStack, BoxProps } from 'styled-system/jsx'

export function Header({
  children,
  rightSlot,
  ...props
}: BoxProps & { rightSlot?: ReactNode }) {
  return (
    <Box
      flexShrink='0'
      flexGrow='0'
      paddingInline='9'
      borderBlockEndWidth='1'
      borderBlockEndColor='border.subtle'
      {...props}
    >
      <HStack alignItems='center' minHeight='11'>
        {children}
        <Box flexGrow='1' />
        {rightSlot}
      </HStack>
    </Box>
  )
}
